<pg-header
  title="Wards"
  ticon="database"
  bckbtn="true"
  bckurl="/setup"
></pg-header>
@if (usrAcsErrMsg == false) {
<div>
  <div>
    <div class="ds-card grid">
      @if (shwLdg) {
      <ds-loading></ds-loading>
      }
      <app-data-grid
        id="gridContainer"
        style="width: 100%"
        [dataSource]="wrdLst"
        [legacyColumns]="columnDefs"
        [searchPanel]="true"
        [filterRow]="true"
        [filterPanel]="true"
        [groupPanel]="true"
        [columnChooser]="true"
        [allowExport]="(USER_PERMISSIONS.exprt_in==1)?true:false"
        exportFileName="LMO Details"
        [pageSize]="10"
        [allowedPageSizes]="[10, 25, 50, 100]"
        [showPageSizeSelector]="true"
        [rowAlternationEnabled]="true"
        [showBorders]="true"
      >
        <app-grid-column
          [showInColumnChooser]="false"
          [visible]="(USER_PERMISSIONS.updt_in==1)?true:false"
          type="buttons"
          [width]="100"
          caption="Edit"
          cellTemplate="editTemplate"
        ></app-grid-column>
        <ng-template appGridCell="editTemplate" let-data="cell"
          ><div>
            <div
              class="cursor-pointer tblEdtBtn"
              (click)="onCellClick('edit',data)"
            >
              Edit
            </div>
          </div></ng-template
        >
        <app-grid-column
          [showInColumnChooser]="false"
          [visible]="(USER_PERMISSIONS.dlte_in==1)?true:false"
          type="buttons"
          [width]="100"
          caption="Delete"
          cellTemplate="delTemplate"
        ></app-grid-column>
        <ng-template appGridCell="delTemplate" let-data="cell"
          ><div>
            <div
              class="cursor-pointer tblDelBtn"
              (click)="onCellClick('delete',data)"
            >
              Delete
            </div>
          </div></ng-template
        >
      </app-data-grid>
    </div>
  </div>
  <nz-drawer
    [nzBodyStyle]="{ height: 'calc(100% - 55px)', overflow: 'auto', 'padding-bottom': '53px' }"
    [nzMaskClosable]="false"
    [nzWidth]="370"
    [nzVisible]="shwSidebar"
    [nzTitle]="sidebarHeading"
    (nzOnClose)="closeSideBar()"
  >
    <div class="mcrpckMrgn">
      <div class="inptLbl">Ward Name</div>
      <nz-input-wrapper [nzSuffix]="inputClearTpl">
        <input
          type="text"
          nz-input
          [(ngModel)]="wrdData.wrd_nm"
          placeholder="please enter ward name"
        />
      </nz-input-wrapper>
    </div>
    <div class="mcrpckMrgn">
      <div class="inptLbl">ULB</div>
      <input
        placeholder="Select ulb"
        nz-input
        [(ngModel)]="wrdData.ulb_nm"
        (ngModelChange)="onChange($event)"
        [nzAutocomplete]="auto"
      />
      <nz-autocomplete #auto>
        @for (d of ulbs; track d) {
        <nz-auto-option [nzValue]="d.ulb_nm" (click)="getULBID(d.ulb_id);"
          >{{d.ulb_nm}}
        </nz-auto-option>
        }
      </nz-autocomplete>
    </div>
    <ng-template #inputClearTpl
      >@if (wrdData.wrd_nm) {
      <i
        nz-icon
        class="ant-input-clear-icon"
        nzTheme="fill"
        nzType="close-circle"
        (click)="wrdData = {}"
      ></i>
      }</ng-template
    >
    @if (shwWrdEditDiv==false && shwWrdDelDiv==false) {
    <button nz-button nzType="primary" class="sbmtBtm" (click)="saveWrd()">
      Submit
    </button>
    } @if (shwWrdEditDiv==true && shwWrdDelDiv==false) {
    <button nz-button nzType="primary" class="sbmtBtm" (click)="saveEditWrd()">
      Update
    </button>
    } @if (shwWrdEditDiv==false && shwWrdDelDiv==true) {
    <button
      nz-button
      nzType="primary"
      class="sbmtBtm"
      nz-popconfirm
      nzPopconfirmTitle="Are you sure delete this Ward?"
      nzPopconfirmPlacement="bottom"
      (nzOnConfirm)="saveDeleteWrd()"
      (nzOnCancel)="cancel()"
    >
      Delete
    </button>
    } @if (shwSidebar) {
    <button nz-button nzType="default" class="cnclBtn" (click)="oncancel()">
      Cancel
    </button>
    }
  </nz-drawer>
  <!-- </div>
  </div>
</div> -->
</div>
} @if (usrAcsErrMsg == true) {
<div class="permMsg">
  <nz-result
    nzStatus="error"
    nzTitle="Access Denied"
    nzSubTitle="You do not have permissions to do this operation. Please contact Administrator to get permissions."
  >
    <!-- <div nz-result-extra>
      <button nz-button nzType="primary" (click)="bckToHm()">Back to home</button>
    </div> -->
  </nz-result>
</div>
}
